import { lazy } from "react";

const TestimonialBlock = lazy(() => import("../../shared/testimonial-block"));
const FacultyBlock = lazy(() => import("../../academics/faculty-block"));
const CareerBlock = lazy(() => import("../../academics/career-block"));
const ADayInTheLifeBlock = lazy(() =>
  import("../../academics/a-day-in-the-life-block")
);

const TextBlockImageRight = lazy(() =>
  import("../../academics/beyond-the-classroom-block")
);
const SimpleBlock = lazy(() => import("./simple-block"));

const PeopleBlock = ({ props }) => {
  const pageBlock = props;
  const map = new Map();
  map.set("career", CareerBlock);
  map.set("staffMembers", FacultyBlock);
  map.set("testimonial", TestimonialBlock);
  map.set("personVideoBlock", ADayInTheLifeBlock);

  const Component = map.get(pageBlock.pageBlockType);
  return Component === undefined ? (
    <p>Need to select a Block Type for none {pageBlock.title}</p>
  ) : (
    <Component pageBlock={pageBlock} />
  );
};

export default PeopleBlock;
